import togglePanel from '../contrib/toggle-panel';

(function () {
  const buttonList = document.querySelectorAll('.toggle-text');
  [].forEach.call(buttonList, (button) => {
    togglePanel(button, {
      panel: 'next',
      panelLabel: 'Texte déplié',
      outsideClose: false,
    });
  });
}());
